import { Component, Input } from '@angular/core';
import { NgIf, DatePipe } from '@angular/common';

@Component({
  selector: 'app-recent-winner-banner',
  standalone: true,
  imports: [NgIf, DatePipe],
  templateUrl: './recent-winner-banner.component.html',
  styleUrl: './recent-winner-banner.component.css'
})
export class RecentWinnerBannerComponent {
  @Input() show: boolean = false;
  @Input() lastWinDate: Date | null = null;
  @Input() contactLockDaysRemaining: number = 0;
}
